<app-loader></app-loader>
<app-important-info-patient *ngIf="(viewBubble$ | async)"></app-important-info-patient>
<router-outlet></router-outlet>
